 var ModalWarningEndOperationTime = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
              m("span.pull-right[style='cursor: pointer;']", {
                onclick: ModalContainerWarningEndOperationTime.close
              }, [
                m("i.glyphicon.glyphicon-remove"),
                m.trust('&nbsp;Закрыть')
              ])
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "C момента начала операции прошло меньше минуты"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerWarningEndOperationTime.close();
                        }
                      }, "Ок")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerWarningEndOperationTime = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerWarningEndOperationTime.container = document.querySelector('#modalWarningEndOperationTime');
    if (!ModalContainerWarningEndOperationTime.container) {
      ModalContainerWarningEndOperationTime.container = document.createElement('div');
      ModalContainerWarningEndOperationTime.container.id = 'modalWarningEndOperationTime';
      ModalContainerWarningEndOperationTime.container.hidden = true;
      document.body.appendChild(ModalContainerWarningEndOperationTime.container);
      m.mount(ModalContainerWarningEndOperationTime.container, m.component(ModalWarningEndOperationTime, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (idElement = null) {
    ModalContainerWarningEndOperationTime.container = document.querySelector('#modalWarningEndOperationTime');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerWarningEndOperationTime.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerWarningEndOperationTime.removeAll = removeAll;
    if (ModalContainerWarningEndOperationTime.container) {
      ModalContainerWarningEndOperationTime.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerWarningEndOperationTime.container.hidden = true;
  }
};
